export default __webpack_public_path__ + "static/media/ep6TN6.fe3ca039.jpg";